class CartOrderNote extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('[data-action="open-editor"]');
    this.editor = this.querySelector('.cart-order-note__editor');
    this.textarea = this.querySelector('[data-cart-note]');
    this.saveBtn = this.querySelector('[data-action="save"]');
    this.cancelBtn = this.querySelector('[data-action="cancel"]');
    this.triggerText = this.querySelector('.cart-order-note__trigger-text');
    this.editorTitle = this.querySelector('.cart-order-note__editor-title span');
    
    this.originalNote = this.textarea ? this.textarea.value : '';
    this.hasNote = this.dataset.hasNote === 'true';
    
    this.init();
  }

  init() {
    if (this.trigger) {
      this.trigger.addEventListener('click', (e) => this.openEditor(e));
    }
    
    if (this.saveBtn) {
      this.saveBtn.addEventListener('click', (e) => this.saveNote(e));
    }
    
    if (this.cancelBtn) {
      this.cancelBtn.addEventListener('click', (e) => this.closeEditor(e));
    }

    this.updateTriggerText();
  }

  openEditor(e) {
    e?.preventDefault();
    this.dataset.editorOpen = 'true';
    
    if (this.editor) {
      this.editor.hidden = false;
    }
    
    if (this.textarea) {
      setTimeout(() => {
        this.textarea.focus();
        this.textarea.setSelectionRange(this.textarea.value.length, this.textarea.value.length);
      }, 10);
    }
  }

  closeEditor(e) {
    e?.preventDefault();
    this.dataset.editorOpen = 'false';
    
    if (this.editor) {
      this.editor.hidden = true;
    }
    
    if (this.textarea && !this.hasNote) {
      this.textarea.value = '';
    } else if (this.textarea) {
      this.textarea.value = this.originalNote;
    }
  }

  async saveNote(e) {
    e?.preventDefault();
    const noteValue = this.textarea ? this.textarea.value.trim() : '';
    
    this.saveBtn.disabled = true;
    this.saveBtn.textContent = 'SAVING...';
    
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          note: noteValue
        })
      });

      if (!response.ok) {
        throw new Error('Failed to save note');
      }

      const cart = await response.json();
      
      this.originalNote = noteValue;
      this.hasNote = noteValue !== '';
      this.dataset.hasNote = this.hasNote ? 'true' : 'false';
      
      this.updateTriggerText();
      
      this.closeEditor(e);
      
    } catch (error) {
      console.error('Error saving order note:', error);
    } finally {
      this.saveBtn.disabled = false;
      this.saveBtn.textContent = 'SAVE';
    }
  }

  updateTriggerText() {
    const addText = this.triggerText?.dataset.textAdd || 'Add order note';
    const editText = this.triggerText?.dataset.textEdit || 'Edit order note';
    
    const text = this.hasNote ? editText : addText;
    
    if (this.triggerText) {
      this.triggerText.textContent = text;
    }
    
    if (this.editorTitle) {
      this.editorTitle.textContent = text;
    }
  }
}

customElements.define('cart-order-note', CartOrderNote);
